/*
 * Cordial-IA 2026-10-11 - Tiroir panier "Calme" : bouton "Ajouter" des suggestions.
 * Delegation sur <cart-drawer> (la zone cart-body est re-rendue par innerHTML, les boutons
 * changent) : POST /cart/add.js avec sections=cart-drawer, puis 'update:cart:drawer' avec la
 * reponse (component-cart-drawer.js remplace les zones dynamiques ; cordial-cart-count.js met la
 * bulle a jour ; cordial-gift-threshold.js rejoue les paliers). Aucun commentaire en fin de ligne.
 *
 * Cordial-IA 2026-10-17 - Upsell "option C" (drafts/upsell-panier-2026-10/BRIEF.md) :
 *  - delegation sur le document, limitee a cart-drawer.cd et a la page /cart (.cd--page, meme snippet en
 *    mode page, hors de <cart-drawer>) : sur /cart, le bouton est ainsi aussi actif ; la page se re-rend
 *    sur 'update:cart:drawer' (assets/cordial-cart-page.js) ;
 *  - message d'erreur cherche dans le bloc du bouton ([data-cd-add-error] le plus proche) ;
 *  - marquage des ajouts venus du bloc ([data-cd-up] = handle, [data-cd-up-slot] = vedette ou liste) :
 *    APRES un ajout reussi, POST /cart/update.js avec un attribut de PANIER PRIVE (prefixe "__", masque au
 *    checkout, absent de cart.attributes en Liquid et de l'API Ajax, visible dans le detail de la commande
 *    dans l'admin). Une cle par saveur : pas besoin de relire la valeur precedente (illisible car privee).
 *    Jamais de propriete de ligne (couperait une saveur en deux lignes). Echec du marquage = silencieux.
 */
(() => {
  if (window.__cordialCartSugg) return;
  window.__cordialCartSugg = true;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const url = (p) => ROOT.replace(/\/$/, '') + p;
  const FAIL = 'Ajout impossible pour le moment.';
  const mark = (btn) => {
    const handle = btn.dataset.cdUp;
    if (!handle) return Promise.resolve();
    const where = btn.closest('.cd--page') ? 'page panier' : 'tiroir';
    const attributes = {};
    attributes['__suggestion_panier_' + handle] = where + ' / ' + (btn.dataset.cdUpSlot || 'liste');
    return fetch(url('/cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes })
    }).catch(() => {});
  };
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cd-add]');
    if (!btn || btn.getAttribute('aria-busy') === 'true') return;
    if (!btn.closest('cart-drawer.cd, .cd--page')) return;
    const id = parseInt(btn.dataset.cdAdd, 10);
    if (!id) return;
    const box = btn.closest('.cd-sugg') || btn.closest('cart-drawer.cd, .cd--page');
    const err = box ? box.querySelector('[data-cd-add-error]') : null;
    btn.setAttribute('aria-busy', 'true');
    if (err) { err.hidden = true; err.textContent = ''; }
    try {
      const res = await fetch(url('/cart/add.js'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: 'cart-drawer' })
      });
      const json = await res.json();
      if (!res.ok || json.status) {
        if (err) { err.textContent = json.description || json.message || FAIL; err.hidden = false; }
        btn.removeAttribute('aria-busy');
        return;
      }
      await mark(btn);
      if (window.eventBus) window.eventBus.emit('update:cart:drawer', json);
      else location.reload();
    } catch (ex) {
      if (err) { err.textContent = FAIL; err.hidden = false; }
      btn.removeAttribute('aria-busy');
    }
  });
})();
